import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Card, CardContent, Typography, Grid } from "@material-ui/core";
import { formatDate, createRowSelector, isStaffUser } from "utils";
import { PeopleListing, CrudOptions } from "frame/components";
import { StaffTrainingLookup } from "features/health-and-safety";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		position: "relative",
		marginBottom: theme.spacing(2),
		"&:hover": {
			cursor: "pointer",
		},
	},
	container: {
		marginTop: theme.spacing(0.5),
		marginLeft: theme.spacing(1),
	},
	content: {
		padding: theme.spacing(2),
		flexGrow: 1,
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			flexWrap: "wrap",
		},
		"&:last-child": {
			paddingBottom: theme.spacing(3),
		},
	},
	label: {
		color: "#999999",
	},
}));

const StaffTrainingCard = ({
	training,
	role,
	onAppend,
	onEdit,
	onDelete,
	onView,
	onEmail,
}) => {
	const classes = useStyles();
	const onRowSelect = createRowSelector(onView);

	const id = {
		id: training.id,
		form: "staff-training",
	};

	return (
		<Card className={classes.root} onClick={onRowSelect}>
			<CardContent className={classes.content}>
				<Grid className={classes.container} container spacing={2}>
					<Grid item md={3} xs={6}>
						<Typography variant="body2" className={classes.label}>
							Date
						</Typography>
						<Typography variant="h5">
							{formatDate(training.createdAt)}
						</Typography>
					</Grid>
					<Grid item md={3} xs={6}>
						<Typography variant="body2" className={classes.label}>
							Training Topic Name
						</Typography>
						<Typography variant="h5">
							<StaffTrainingLookup
								id={training.staffTrainingTopicId}
							/>
						</Typography>
					</Grid>
					<Grid item md={3} xs={6}>
						<Typography variant="body2" className={classes.label}>
							Valid until
						</Typography>
						<Typography variant="h5">
							<StaffTrainingLookup
								id={training.staffTrainingTopicId}
								validUntil
							/>
						</Typography>
					</Grid>
					<Grid item md={3} xs={12}>
						<PeopleListing
							title="Participant(s)"
							people={training.people}
							otherPeople={training.otherPeople}
						/>
					</Grid>
					<div className="ignore">
						{!isStaffUser(role) && (
							<CrudOptions
								id={id}
								onView={onView}
								onAppend={onAppend}
								onDelete={() => onDelete(id)}
								onEmail={onEmail}
							/>
						)}
					</div>
				</Grid>
			</CardContent>
		</Card>
	);
};

StaffTrainingCard.propTypes = {
	training: PropTypes.object.isRequired,
	onAppend: PropTypes.func.isRequired,
	onEdit: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
	onView: PropTypes.func.isRequired,
	role: PropTypes.string.isRequired,
};

export default StaffTrainingCard;
